<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <tt-select ttLabel="language" [(ttModel)]="setting.language_id" (ttModelChange)="onChanged($event, 'language_id')" [ttData]="selectListLanguages" ttDataId="item_id" ttDataName="item_name"></tt-select>

        <form class="form-horizontal sp-0" name="formHelpDocSearch" novalidate (ngSubmit)="searchItems()" method="get" role="form">
            <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListDocuments"></tt-list>
</tt-page>
